import { render } from "./Selections.vue?vue&type=template&id=3137323b&scoped=true&lang=pug"
import script from "./Selections.vue?vue&type=script&lang=js"
export * from "./Selections.vue?vue&type=script&lang=js"

import "./Selections.vue?vue&type=style&index=0&id=3137323b&lang=scss"
import "./Selections.vue?vue&type=style&index=1&id=3137323b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3137323b"]])

export default __exports__